/**
 * ProjectionCard Component
 * 
 * Card de projeção de fechamento do mês.
 */

import React from 'react'
import './ProjectionCard.css'

function ProjectionCard({ data, onActionClick }) {
  if (!data) {
    return null
  }

  const formatCurrency = (val) => 
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)

  return (
    <div className="projection-card">
      <div className="projection-card-background" />
      <div className="projection-card-content">
        <div className="projection-card-header">
          <div className="projection-card-icon">
            <span>📊</span>
          </div>
          <h4 className="projection-card-title">Projeção de Fechamento</h4>
        </div>
        <p className="projection-card-description">
          Baseado no ciclo financeiro atual, projetamos um saldo de{' '}
          <span className="projection-card-highlight">
            {formatCurrency(data.projectedBalance || 0)}
          </span>{' '}
          para o fim do mês corrente.
        </p>
        {onActionClick && (
          <button 
            className="projection-card-action"
            onClick={onActionClick}
          >
            Antecipar Recebíveis
          </button>
        )}
      </div>
    </div>
  )
}

export default ProjectionCard
